module.exports = __webpack_public_path__ + "static/media/DBSO.62512893.svg";